import { Anchor } from "antd";

function Header(args) {
  return (
    <div className="header" style={{position:"sticky",top:"0", zIndex:100,    display:"flex",flexDirection:"row",height:"7rem",width:"100%", justifyContent:"end",}} >
      <a href="/about" className="logo" style={{width:"6rem",marginRight:"auto", marginLeft:"1rem"}}><img src={args.logo} alt="logo" style={{height:"100%",width:"auto"}}/></a>
      <div>
        <Anchor
          direction="horizontal"
          style={{
            color:"white",
            marginRight:"1rem"
          }}
          items={[
            {
              key: 'giris',
              href: '/#giris',
              title: 'Giriş',
            },
            {
              key: 'amac',
              href: '/#amac',
              title: 'Amacımız',
            },
            {
              key: 'algoritmalar',
              href: '/#algoritmalar',
              title: 'Algoritmalar',
            },
            {
              key: 'MiniBit',
              href: '/#MiniBit',
              title: 'MiniBit',
            },
          ]}
        />
      </div>
      
    </div>
  );
}

export default Header;